import React, { FC } from "react";
import { Grid, Hidden, Button, makeStyles, Box } from "@material-ui/core";
import { IntermediarioLogo } from "./IntermediarioLogo";
import { AragLogo } from "./AragLogo";
import { ReactComponent as IconaMenu } from "../icons/IconaMenu.svg";

interface Props {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  showMenuButton: boolean;
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 42,
    alignItems: "center",
    position: "relative",
    [theme.breakpoints.up("sm")]: {
      marginBottom: 50,
    },
    [theme.breakpoints.down("sm")]: {
      paddingTop: 23,
      marginBottom: 20,
    },
  },
  menuContainer: {
    position: "absolute",
    right: 0,
    top: 28,
  },
  menuButton: {
    textTransform: "initial",
    width: 100,
    minHeight: 40,
  },
}));

export const Logo: FC<Props> = ({ onClick, showMenuButton = false }: Props) => {
  const classes = useStyles();
  return (
    <Grid container className={classes.root}>
      <Box>
        <AragLogo />
      </Box>
      <Box style={{ marginLeft: 22 }}>
        <IntermediarioLogo />
      </Box>
      {showMenuButton && (
        <Hidden mdUp>
          <Box className={classes.menuContainer}>
            <Button onClick={onClick}>
              <IconaMenu className={classes.menuButton} />
            </Button>
          </Box>
        </Hidden>
      )}
    </Grid>
  );
};
